<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="70%"
    >
      <div style="width: 100%;height: 500px;">
        <div class="video-left">
          <p>
            <span>已选中：</span> {{resourcesDetail.resourcesName}}
          </p>
          <ul style="margin: 5px;overflow: auto;height: 450px">
            <li v-for=" (item,index) in detail.trainingResourcesDetailVos" @click="study(item)">
              <div>
                <h5 style="color:#5D8C82;font-size: 15px;">附件 {{ index + 1 }}： {{ item.resourcesName }}</h5>
                <p style="color:#999; font-size: 14px;margin-top: 5px">
                  时长：{{ item.suggestedDuration }}分钟
                </p>
              </div>
            </li>
          </ul>

        </div>

        <div class="video-right">

          <div class="f-c-c study-box" style="height: 90%" v-if="resourcesDetail.resourcesPath.indexOf('.pdf') > -1">
            <iframe style="height:50vh;width:100%;"
                    :src="resourcesDetail.resourcesUrl" frameborder="0"></iframe>
          </div>
          <div class="study-box f-c-c"
               v-show="resourcesDetail.resourcesPath.indexOf('.pdf') == -1">
            <trainingVideo ref="trainingVideo" :sourceUrl="getResourcesPath(resourcesDetail.resourcesUrl)">
            </trainingVideo>
            <br/>
          </div>
        </div>


      </div>
      <!--      <span slot="footer" class="dialog-footer">-->
      <!--    <el-button @click="dialogVisible = false">取 消</el-button>-->
      <!--    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
      <!--  </span>-->
    </el-dialog>

  </div>
</template>


<script>
import trainingVideo from "@/components/training/trainingVideo";

export default {
  components: {trainingVideo},
  data() {
    return {
      dialogVisible: false,
      detail: {
        createdBy: undefined,
        dataIntroduction: undefined,
        dataName: undefined,
        dataPrice: undefined,
        department: undefined,
        departmentId: undefined,
        expireDay: undefined,
        id: undefined,
        isMallImport: undefined,
        joinPaperVos: undefined,
        professionalCategory: undefined,
        professionalCategoryCheckValue: undefined,
        professionalCategoryItem: undefined,
        professionalCategoryName: undefined,
        professionalCategorySubItem: undefined,
        questionsDirectoryId: undefined,
        questionsDirectoryName: undefined,
        sourceId: undefined,
        teacherName: undefined,
        trainingResourcesDetailVos: [],
        updatedBy: undefined,
      },
      resourcesDetail: {
        dataPrice: undefined,
        expireDay: undefined,
        resourcesFileId: undefined,
        resourcesName: undefined,
        resourcesPath: 'sssw.pdf',
        resourcesType: undefined,
        resourcesUrl: undefined,
        suggestedDuration: undefined,
        suggestedDurationMax: undefined,
        totalSuggestedDuration: undefined,
      },
      title:undefined,
    };
  },
  methods: {
    videoShow(data) {
      this.$nextTick(() => {
        console.log(data)
        this.detail = data;
        this.title=data.dataName;
        this.resourcesDetail=data.trainingResourcesDetailVos[0]
        this.dialogVisible = true;
      })

    },
    study(data) {
      // console.log(data)
      this.resourcesDetail = data;
    },
    /**
     * 获取课件路径
     **/
    getResourcesPath(path) {
      if (!path) {
        return path;
      }
      if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
      }
      if (path.startsWith("https://")) {
        return path;
      }
      return "http://" + path;
    },
  },
};
</script>


<style ang="scss" scoped>

.video-left {
  display: inline-block;
  /*border: red 1px solid;*/
  width: 30%;
  height: 100%;
}

.video-left ul li {
  cursor:pointer;
  margin-top: 8px;
  /*border: 1px solid blue;*/
  background-color: #F2F2F2;
  /*height: 50px;*/

}

.video-right {
  display: inline-block;
  width: 66%;
  float: right;
  /*border: black 1px solid;*/
  height: 100%;
  margin-left: 20px;
}


/deep/ .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 200px);
  max-width: calc(100% - 30px);
}


/deep/ .el-dialog .el-dialog__body {
  /*flex:1;*/
  /*overflow: auto;*/
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/training/videoList.vue